<template>
  <div class="message-system multiline-ellipsis">
    {{ getOpType() }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    getOpType() {
      if (this.message.systemType === "revoked") {
        return (
          (this.message.isSelf ? "您" : this.message.nick) + "撤回了一条消息"
        );
      } else if (this.message.systemType === "allMute") {
        // 全员禁言或者解除禁言
        if (this.message.isMute) {
          return (
            "老师已设置全员禁言 " + this.timestampToHM(this.message.handleTime)
          );
        } else {
          return (
            "老师已解除全员禁言 " + this.timestampToHM(this.message.handleTime)
          );
        }
      } else if (this.message.systemType === "personMute") {
        // 个人解除禁言或者禁言
        // 全员禁言或者解除禁言
        if (this.message.isMute) {
          return "您被老师禁言 " + this.timestampToHM(this.message.handleTime);
        } else {
          return "您被解除禁言 " + this.timestampToHM(this.message.handleTime);
        }
      } else if (this.message.systemType === "enterRoom") {
        return (
          this.message.nickname +
          "加入课堂 " +
          this.timestampToHM(this.message.handleTime)
        );
      } else if (this.message.systemType === "handUp") {
        return (
          this.message.nickname +
          "举手 " +
          this.timestampToHM(this.message.handleTime)
        );
      }
    },
    timestampToHM(timestamp) {
      if (!timestamp) {
        return "";
      }
      // 处理秒级时间戳（10位）
      if (timestamp.toString().length === 10) {
        timestamp *= 1000;
      }

      const date = new Date(timestamp);
      const hours = String(date.getHours()).padStart(2, "0"); // 补零，确保两位数
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${hours}:${minutes}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.message-system {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #86909c;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  text-align: center;
  margin-bottom: 16px;
  padding: 0 40px;
}
</style>
